import React, { useState } from 'react';
import DivBetween from '../../../components/div/DivBetween';
import DivEnd from '../../../components/div/DivEnd';
import { Actions } from '../../../../client/Actions';
import ConfirmButton from '../../../components/button/ConfirmButton';
import { useNavigate } from 'react-router-dom';
import { Badge, Button, ButtonGroup, Dropdown } from 'react-bootstrap';
import DivStart from '../../../components/div/DivStart';
import StayStatusIcon from '../../../components/lakeview/StayStatusIcon';
import { useGlobalConfig } from '../../../components/globalConfig/GlobalConfigContext';
import Form from '../../../components/form/Form';
import { useLoaderContext } from '../../../components/loader/LoaderContext';
import TrickButton from '../../../components/button/TrickButton';
import Tooltip from '../../../components/tooltip/Tooltip';
import { FaBars, FaInfoCircle, FaMoneyBill, FaUsers } from 'react-icons/fa';

const ResultHeader = ({ reservation, onReload }) => {
  if (!reservation) return <></>;

  const {
    fullRefundDueDays, partialRefundDueDays, partialRefundPercentage, isLoading
  } = useGlobalConfig();
  const { showLoader, hideLoader } = useLoaderContext();

  const [cancelData, setCancelData] = useState();
  const [cancelReady, setCancelReady] = useState(false);
  const [checkoutReady, setCheckoutReady] = useState(false);
  const [checkoutData, setCheckoutData] = useState();
  const [showActionsMobile, setShowActionsMobile] = useState(false);




  const calculateDaysUntilStart = () => {
    if (!reservation?.startDate || isLoading) return 0;
    const today = new Date();
    const startDate = new Date(reservation.startDate);
    return Math.ceil((startDate - today) / (1000 * 60 * 60 * 24));
  };

  const navigate = useNavigate();

  const handleCheckIn = () => {
    Actions.post(`/reservation/${reservation.id}/checkin`, {}, onReload);
  };

  const handleCancel = () => {
    showLoader();
    Actions.post(
      `/reservation/${reservation.id}/cancel`,
      cancelData,
      (data) => {
        hideLoader();
        onReload(data);
      }
    );
  };
  const handleCheckOut = () => {
    showLoader();
    Actions.post(
      `/reservation/${reservation.id}/checkout`,
      checkoutData,
      (data) => {
        hideLoader();
        onReload(data);
      }
    );
  };

  const handleEdit = () => {
    navigate(`/checkout/${reservation.houses[0].id}/` + reservation.id, {});
  };

  if (isLoading) {
    return <></>;
  }
  const fields = [
    {
      name: 'daysUntilStart',
      label: 'Dni do przyjazdu',
      column: 1,
      readOnly: true,
      defaultValue: calculateDaysUntilStart()+"",
      type: 'number'
    },
    {
      name: 'description',
      label: 'Powód anulacji',
      column: 1,
      mandatory: false,
      type: 'textarea'
    },
    {
      name: 'refundPercentage',
      label: 'Wartość zwrotu %',
      column: 1,
      suffix: '%',
      maxValue: 100,
      minValue: 0,
      scale: 4,
      defaultValue: `${reservation.calculatedRefundPercentage}`,
      mandatory: true,
      type: 'number'
    }
  ];

  const checkoutFields = [
    {
      name: 'checkoutNotes',
      label: 'Notatki wymeldowania',
      column: 1,
      mandatory: false,
      type: 'textarea'
    },
    {
      name: 'securityDepositRefundPercentage',
      label: 'Kaucja do zwrotu %',
      column: 1,
      suffix: '%',
      maxValue: 100,
      minValue: 0,
      scale: 4,
      defaultValue: '100',
      mandatory: true,
      type: 'number'
    }
  ];


  const renderActionButtons = () => (
    <>
      <TrickButton text="Status płatności jest obliczany automatycznie przy dodanie płatności lub wymelodwaniu." />
      {reservation.stayStatus !== 'CANCELLED' && (
        <>

          <Button size="sm" variant="secondary" onClick={handleEdit}>
            Zmień parametry
          </Button>

          {reservation.stayStatus !== 'CHECKED_OUT' && (
            <ConfirmButton
              size="sm"
              confirmTitle="Anulacja"
              variant="danger"
              canConfirm={cancelReady}
              onConfirm={handleCancel}
              form={
                <Form
                  onReadyUpdate={setCancelReady}
                  formDataChanged={setCancelData}
                  noActions={true}
                  fields={{ config: { columns: 1 }, fields: fields }}
                />
              }
            >
              Anuluj
            </ConfirmButton>
          )
          }

          {reservation.stayStatus === 'NOT_CHECKED_IN' && (
            <ConfirmButton
              size="sm"
              confirmTitle="Zameldowanie"
              confirmDescription="Czy napewno chcesz zameldować?"
              variant="primary"
              onConfirm={handleCheckIn}
            >
              Zamelduj
            </ConfirmButton>
          )}
          {reservation.stayStatus === 'CHECKED_IN' && (
            <ConfirmButton
              size="sm"
              confirmTitle="Wymelduj"
              variant="primary"
              canConfirm={checkoutReady}
              onConfirm={handleCheckOut}
              form={
                <Form
                  onReadyUpdate={setCheckoutReady}
                  formDataChanged={setCheckoutData}
                  noActions={true}
                  fields={{ config: { columns: 1 }, fields: checkoutFields }}
                />
              }
            >
              Wymelduj
            </ConfirmButton>

          )}
        </>
      )}
    </>
  );



  const renderDropdownActions = () => (
    <Dropdown as={ButtonGroup} align="end">
      <Dropdown.Toggle variant="outline-primary" size="sm" id="dropdown-basic">
        <FaBars />
      </Dropdown.Toggle>

      <Dropdown.Menu className="shadow-sm p-2">
        <Dropdown.Item as="div">
          <TrickButton text="Status płatności jest obliczany automatycznie przy dodanie płatności lub wymelodwaniu." />
        </Dropdown.Item>

        {reservation.stayStatus !== 'CANCELLED' && (
          <>
            <Dropdown.Item as="div">
              <Button size="sm" variant="secondary" onClick={handleEdit}>
                Zmień parametry
              </Button>
            </Dropdown.Item>

            {reservation.stayStatus !== 'CHECKED_OUT' && (
              <Dropdown.Item as="div">
                <ConfirmButton
                  size="sm"
                  confirmTitle="Anulacja"
                  variant="danger"
                  canConfirm={cancelReady}
                  onConfirm={handleCancel}
                  form={
                    <Form
                      onReadyUpdate={setCancelReady}
                      formDataChanged={setCancelData}
                      noActions={true}
                      fields={{ config: { columns: 1 }, fields: fields }}
                    />
                  }
                >
                  Anuluj
                </ConfirmButton>
              </Dropdown.Item>
            )}

            {reservation.stayStatus === 'NOT_CHECKED_IN' && (
              <Dropdown.Item as="div">
                <ConfirmButton
                  size="sm"
                  confirmTitle="Zameldowanie"
                  confirmDescription="Czy napewno chcesz zameldować?"
                  variant="primary"
                  onConfirm={handleCheckIn}
                >
                  Zamelduj
                </ConfirmButton>
              </Dropdown.Item>
            )}

            {reservation.stayStatus === 'CHECKED_IN' && (
              <Dropdown.Item as="div">
                <ConfirmButton
                  size="sm"
                  confirmTitle="Wymelduj"
                  variant="primary"
                  canConfirm={checkoutReady}
                  onConfirm={handleCheckOut}
                  form={
                    <Form
                      onReadyUpdate={setCheckoutReady}
                      formDataChanged={setCheckoutData}
                      noActions={true}
                      fields={{ config: { columns: 1 }, fields: checkoutFields }}
                    />
                  }
                >
                  Wymelduj
                </ConfirmButton>
              </Dropdown.Item>
            )}
          </>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );


  return (
    <DivBetween className="w-100">
      <DivStart className={'gap-2'}>
        <h3 className="d-inline-flex align-items-center gap-2">
          <StayStatusIcon reservation={reservation} />

          <span className={'text-nowrap d-md-block d-none'}>Szczegóły rezerwacji</span>
          <Badge bg="light" text="dark">{reservation.businessId}</Badge>
          {reservation.paymentDueExpired &&
            <Tooltip
              tooltip={'Minął termin płatności'}
            >
              <FaInfoCircle
                className={"text-danger cursor-pointer"}
                size={25} />


            </Tooltip>}
        </h3>


      </DivStart>
      <DivEnd className="d-flex flex-column flex-md-row gap-2 align-items-md-center w-100">
        {/* Mobile: Hamburger */}
        <div className="d-md-none align-self-end">
          {renderDropdownActions()}
        </div>

        {/* Desktop: show buttons inline */}
        <div className="d-none d-md-flex gap-2 align-items-center">
          {renderActionButtons()}
        </div>
      </DivEnd>
    </DivBetween>
  );
};

export default ResultHeader;
